import { InputHTMLAttributes } from 'react';
import { Control, Controller, Path } from 'react-hook-form';
import OTPInput from 'react-otp-input';
import classNames from 'classnames';

// @ts-ignore lib
import { EMAIL_VERIFICATION_CODE_LENGTH } from '@lootboy/lib/config';

import InputWrapper, {
  IInputWrapperProps,
} from '~/components/atoms/FormControls/InputWrapper';

import styles from './CodeInput.module.scss';

function OtpInputSegment({
  innerInputProps,
  className,
}: {
  innerInputProps: InputHTMLAttributes<HTMLInputElement>;
  className: string;
}) {
  return (
    <input
      {...innerInputProps}
      className={className}
    />
  );
}

type TCodeInputProps<FormValues> = IInputWrapperProps & {
  control: Control<FormValues>;
  name: Path<FormValues>;
};

export function CodeInput<FormValues>({
  label,
  id,
  errorAction,
  error,
  control,
  name,
}: TCodeInputProps<FormValues>): JSX.Element {
  return (
    <InputWrapper
      label={label}
      id={id}
      error={error}
      errorAction={errorAction}
    >
      <Controller
        control={control}
        name={name}
        render={({ field }) => {
          const parsedValue = (field.value ?? '') as string;

          const inputSegmentClassName = classNames(
            styles.inputSegment,
            error && styles.error,
            // success styling gets applied when all code inputs are filled
            parsedValue.length === EMAIL_VERIFICATION_CODE_LENGTH &&
              styles.success,
          );

          return (
            <OTPInput
              onChange={field.onChange}
              value={parsedValue}
              numInputs={EMAIL_VERIFICATION_CODE_LENGTH}
              inputType="text"
              shouldAutoFocus
              renderInput={(inputProps) => (
                <OtpInputSegment
                  innerInputProps={inputProps}
                  className={inputSegmentClassName}
                />
              )}
            />
          );
        }}
      />
    </InputWrapper>
  );
}
